import React from 'react';

import Button from '../components/Button.jsx'
import { alfred } from '../lib/APIClient'

/**
 * 
 */
class AlfredTest extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      download: "LOL"
    }
  }

  render() {
    return (
      <div style={{padding: 50}}>
        <Button onClick={() => { console.log("Se hace click"); alfred() }}>It's report time!</Button>
      </div>
    )
  }
}

export default AlfredTest
